{
  "name": "p360-mobile-app",
  "version": "4.5.3",
  "description": "P360 mobile application",
  "author": "Luis García Castro",
  "homepage": "http://www.bisigma.com",
  "private": true,
  "scripts": {
    "ng": "node --max_old_space_size=8000 ./node_modules/@angular/cli/bin/ng",
    "cap": "cap",
    "ionic": "ionic",
    "start": "ionic serve",
    "build": "yarn ng build --configuration production",
    "build:dev": "yarn ng build --configuration development",
    "watch": "yarn ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "update-sprite": "svg-sprite -s --symbol-dest src/assets --symbol-sprite svgsprites.svg src/assets/p360-svgs/*.svg",
    "capbuild": "ionic cap build --no-open --configuration production",
    "capsync": "ionic cap sync",
    "capbuild.android": "yarn capbuild android",
    "capbuild.ios": "yarn capbuild ios",
    "run.android": "ionic cap run android -l --external",
    "run.ios": "ionic cap run ios -l --external"
  },
  "dependencies": {
    "@angular/animations": "^22.2.1",
    "@angular/common": "^22.2.1",
    "@angular/compiler": "^22.2.1",
    "@angular/core": "^22.2.1",
    "@angular/forms": "^22.2.1",
    "@angular/platform-browser": "^22.2.1",
    "@angular/platform-browser-dynamic": "^22.2.1",
    "@angular/router": "^22.2.1",
    "@awesome-cordova-plugins/core": "^6.6.0",
    "@awesome-cordova-plugins/diagnostic": "^6.6.0",
    "@awesome-cordova-plugins/file": "^6.6.0",
    "@awesome-cordova-plugins/sqlite": "^6.6.0",
    "@capacitor-community/fcm": "^8.2.2",
    "@capacitor-community/firebase-analytics": "^8.1.0",
    "@capacitor/android": "^8.5.2",
    "@capacitor/app": "^8.1.1",
    "@capacitor/app-launcher": "^8.0.1",
    "@capacitor/browser": "^8.0.4",
    "@capacitor/camera": "^8.2.4",
    "@capacitor/core": "^8.5.2",
    "@capacitor/device": "^8.0.3",
    "@capacitor/geolocation": "^8.2.2",
    "@capacitor/google-maps": "^8.0.1",
    "@capacitor/haptics": "^8.0.2",
    "@capacitor/ios": "^8.5.2",
    "@capacitor/keyboard": "^8.0.5",
    "@capacitor/network": "^8.0.1",
    "@capacitor/preferences": "^8.0.1",
    "@capacitor/push-notifications": "^8.1.2",
    "@capacitor/screen-orientation": "^8.0.1",
    "@capacitor/splash-screen": "^8.0.2",
    "@capacitor/status-bar": "^8.0.3",
    "@ionic/angular": "^9.0.6",
    "@ionic/angular-server": "^9.0.6",
    "@ionic/core": "^9.0.6",
    "@ionic/storage-angular": "^4.0.0",
    "@ngrx/core": "^1.2.0",
    "@ngrx/store": "^22.0.1",
    "@ngx-translate/core": "^18.0.0",
    "@ngx-translate/http-loader": "^18.0.0",
    "@primeicons/angular": "^8.0.2",
    "@primeuix/themes": "^3.0.0",
    "@tailwindcss/postcss": "^4.1.18",
    "@von-development-studio/angular-rest-service": "^22.0.1",
    "@von-development-studio/primeng-helper": "^22.0.4",
    "chart.js": "^4.4.2",
    "cordova-plugin-file": "^8.0.1",
    "cordova-sqlite-storage": "^7.0.0",
    "cordova-support-android-plugin": "^2.0.4",
    "cordova.plugins.diagnostic": "^7.1.4",
    "deck.gl": "^9.4.0",
    "devextreme": "26.1.5",
    "devextreme-angular": "26.1.5",
    "emoji-toolkit": "^11.0.0",
    "es6-promise-plugin": "^4.2.2",
    "eslint-config-prettier": "10.1.5",
    "eslint-plugin-prettier": "5.5.1",
    "gmaps-heatmap": "^1.0.2",
    "heatmap.js": "^2.0.5",
    "katex": "^0.19.0",
    "marked": "^18.1.0",
    "marked-katex-extension": "^5.1.13",
    "ngx-cookie-service": "^22.0.0",
    "ngx-markdown": "^22.1.0",
    "pdf-lib": "^1.17.1",
    "primeclt": "^0.1.5",
    "primeicons": "^8.0.2",
    "primeng": "22.1.2",
    "prismjs": "^1.30.0",
    "quill": "^2.0.3",
    "rxjs": "^7.8.2",
    "swiper": "^11.0.5",
    "tailwindcss-primeui": "0.6.1",
    "tslib": "^2.8.1",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^20.3.0",
    "@angular-eslint/eslint-plugin": "^20.3.0",
    "@angular-eslint/eslint-plugin-template": "^20.3.0",
    "@angular-eslint/template-parser": "^20.3.0",
    "@angular/build": "^22.2.4",
    "@angular/cdk": "^22.2.4",
    "@angular/cli": "^22.2.4",
    "@angular/compiler-cli": "^22.2.1",
    "@angular/language-service": "^22.2.1",
    "@capacitor/assets": "^3.0.5",
    "@capacitor/cli": "^8.5.2",
    "@fortawesome/fontawesome-free": "^6.5.1",
    "@ionic/angular-toolkit": "^13.0.0",
    "@ionic/cli": "^7.2.1",
    "@types/google.maps": "^3.55.5",
    "@types/node": "^24.10.1",
    "@typescript-eslint/eslint-plugin": "^6.20.0",
    "@typescript-eslint/parser": "^6.20.0",
    "@vitest/browser-playwright": "^5.0.5",
    "@vitest/browser-preview": "^5.0.5",
    "autoprefixer": "^10.4.20",
    "eslint": "9.30.1",
    "eslint-plugin-import": "2.32.0",
    "eslint-plugin-jsdoc": "^48.0.4",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "istanbul-lib-instrument": "^6.0.3",
    "jsdom": "^30.1.2",
    "material-icons": "^1.13.12",
    "playwright": "^1.63.0",
    "postcss": "^8.5.29",
    "postcss-import": "^17.0.0",
    "prettier": "^3.8.1",
    "svg-sprite": "^2.0.4",
    "tailwindcss": "4.1.11",
    "ts-node": "^10.9.2",
    "typescript": "^6.0.3",
    "vitest": "^5.0.5"
  },
  "resolutions": {
    "**/basic-ftp": "6.2.1",
    "**/esbuild": "0.25.0",
    "**/fflate": "0.7.5",
    "**/image-size": "2.0.3",
    "**/minimatch": "9.0.7",
    "**/sharp": "0.35.5",
    "**/swiper": "12.1.3",
    "**/tar": "7.5.21",
    "**/tmp": "0.2.7",
    "**/uuid": "11.1.1",
    "**/vite": "8.3.3",
    "**/zod": "4.6.6"
  }
}
